export const GET_DIAGNOSIS_REQUEST = 'GET_DIAGNOSIS_REQUEST';
export const GET_DIAGNOSIS_SUCCESS = 'GET_DIAGNOSIS_SUCCESS';
export const GET_DIAGNOSIS_FAIL = 'GET_DIAGNOSIS_FAIL';